// Catalog data: 7 categories, demo products per category.
// Images are real Unsplash URLs from design_guidelines + verified LED imagery.

export const CATEGORIES = [
  {
    slug: "led-tri-proof-light",
    name: "LED Tri-Proof Light",
    short: "Tri-Proof",
    description:
      "IP65-rated linear luminaires built for warehouses, parking decks and food-processing facilities. Sealed against dust, water and impact.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/fvrza80v_9290713.jpg",
    icon: "shield",
  },
  {
    slug: "led-bulbs",
    name: "LED Bulbs",
    short: "Bulbs",
    description:
      "Standard retrofit lamps in E27, E14, GU10 and B22 bases. 3-year warranty. Up to 100 lm/W.",
    image:
      "https://images.unsplash.com/photo-1532007271951-c487760934ae?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    icon: "lightbulb",
  },
  {
    slug: "led-panels",
    name: "LED Panels",
    short: "Panels",
    description:
      "Slim ceiling panels for offices, schools and clinics. UGR<19, flicker-free, 5-year warranty.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/kg5yszzt_led-panelen-frame-rand-verlicht-linear-vierkant-open-systeemplafond-closeup-ledwinkel-online-1600x1200.webp.jpeg",
    icon: "square",
  },
  {
    slug: "led-ceiling-lights",
    name: "LED Ceiling Lights",
    short: "Ceiling",
    description:
      "Surface-mounted luminaires with integrated drivers. Ideal for hallways, garages and utility spaces.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ai1945pj_95313-1000x_orig.jpg",
    icon: "circle",
  },
  {
    slug: "led-linear-lights",
    name: "LED Linear Lights",
    short: "Linear",
    description:
      "Continuous-run linkable battens. Under-cabinet, retail shelving and workshop lighting.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/h3e6f3dl_51YDbHZ-PJL._AC_SL1100_.jpg",
    icon: "minus",
  },
  {
    slug: "led-floodlights",
    name: "LED Floodlights",
    short: "Flood",
    description:
      "Outdoor 10W – 200W projectors. IP65, IK08. Façades, parking lots, sports fields.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/yi2leauy_71TYrj6x4cL._AC_UF1000%2C1000_QL80_.jpg",
    icon: "sun",
  },
  {
    slug: "recessed-downlight",
    name: "Recessed Downlight",
    short: "Downlight",
    description:
      "Trim-fit downlights and spots, fixed or tiltable. Residential, retail and hospitality.",
    image:
      "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/10waaupc_47201-2-1600x_orig.jpg",
    icon: "target",
  },
];

const mkProduct = (
  code,
  name,
  category,
  watt,
  lumen,
  cct,
  ip,
  warranty,
  image,
  highlights
) => ({
  id: code,
  code,
  name,
  category,
  watt,
  lumen,
  cct,
  ip,
  warranty,
  image,
  highlights,
});

export const PRODUCTS = [
  // LED BULBS
  mkProduct(
    "21200",
    "LX PAR16 E27 5W",
    "led-bulbs",
    "5W",
    "400 lm",
    "3000K",
    "IP20",
    "3 years",
    "https://images.unsplash.com/photo-1532007271951-c487760934ae?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ["E27 base", "Warm white", "80+ CRI", "Instant on"]
  ),
  mkProduct(
    "21205",
    "LX A60 E27 9W",
    "led-bulbs",
    "9W",
    "806 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://images.unsplash.com/photo-1532007271951-c487760934ae?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ["Equivalent to 60W incandescent", "Neutral white", "Beam angle 220°"]
  ),
  mkProduct(
    "21208",
    "LX C37 E14 6W",
    "led-bulbs",
    "6W",
    "540 lm",
    "2700K",
    "IP20",
    "3 years",
    "https://images.unsplash.com/photo-1532007271951-c487760934ae?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ["Candle shape", "Decorative", "Dimmable variant available"]
  ),
  mkProduct(
    "21212",
    "LX GU10 5W",
    "led-bulbs",
    "5W",
    "400 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://images.unsplash.com/photo-1532007271951-c487760934ae?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ["GU10 spot", "38° beam", "Aluminium body"]
  ),

  // LED PANELS
  mkProduct(
    "10100",
    "LX 4HOME 60x60 40W",
    "led-panels",
    "40W",
    "4000 lm",
    "4000K",
    "IP20",
    "5 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/kg5yszzt_led-panelen-frame-rand-verlicht-linear-vierkant-open-systeemplafond-closeup-ledwinkel-online-1600x1200.webp.jpeg",
    ["UGR<19", "Flicker-free", "Office grade", "595x595 mm"]
  ),
  mkProduct(
    "10110",
    "LX SquareSlim 30x30 18W",
    "led-panels",
    "18W",
    "1800 lm",
    "4000K",
    "IP20",
    "5 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ugdlxr6t_backlit_6.jpg",
    ["Backlit", "Edge-lit option", "Surface kit available"]
  ),
  mkProduct(
    "10115",
    "LX Round 22W",
    "led-panels",
    "22W",
    "2200 lm",
    "3000K",
    "IP20",
    "5 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ai1945pj_95313-1000x_orig.jpg",
    ["Ø225 mm", "Warm white", "Trim-less"]
  ),
  mkProduct(
    "10118",
    "LX 120x30 36W",
    "led-panels",
    "36W",
    "3600 lm",
    "4000K",
    "IP20",
    "5 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ugdlxr6t_backlit_6.jpg",
    ["Linear format", "Drop-ceiling fit"]
  ),

  // LED FLOODLIGHTS
  mkProduct(
    "46550",
    "LX PROFlood 50W",
    "led-floodlights",
    "50W",
    "5500 lm",
    "5000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/yi2leauy_71TYrj6x4cL._AC_UF1000%2C1000_QL80_.jpg",
    ["IK08", "Cool daylight", "Asymmetric reflector"]
  ),
  mkProduct(
    "46560",
    "LX PROFlood 100W",
    "led-floodlights",
    "100W",
    "11000 lm",
    "5000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/yi2leauy_71TYrj6x4cL._AC_UF1000%2C1000_QL80_.jpg",
    ["Long-distance throw", "Stadium grade"]
  ),
  mkProduct(
    "46570",
    "LX PROFlood 150W",
    "led-floodlights",
    "150W",
    "16500 lm",
    "4000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/yi2leauy_71TYrj6x4cL._AC_UF1000%2C1000_QL80_.jpg",
    ["Tempered glass", "Adjustable bracket"]
  ),

  // LED CEILING LIGHTS
  mkProduct(
    "30210",
    "LX CeilingPro 18W",
    "led-ceiling-lights",
    "18W",
    "1800 lm",
    "4000K",
    "IP44",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ai1945pj_95313-1000x_orig.jpg",
    ["Ø300 mm", "Splash resistant", "Hallway/bathroom"]
  ),
  mkProduct(
    "30215",
    "LX CeilingPro 24W",
    "led-ceiling-lights",
    "24W",
    "2400 lm",
    "3000K",
    "IP44",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ai1945pj_95313-1000x_orig.jpg",
    ["Ø350 mm", "Warm white", "Microwave sensor option"]
  ),
  mkProduct(
    "30220",
    "LX CeilingPro 32W",
    "led-ceiling-lights",
    "32W",
    "3200 lm",
    "4000K",
    "IP44",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/ai1945pj_95313-1000x_orig.jpg",
    ["Ø420 mm", "Common rooms"]
  ),

  // LED LINEAR LIGHTS
  mkProduct(
    "55100",
    "LX Linear T5 14W 1200mm",
    "led-linear-lights",
    "14W",
    "1400 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/cruueskv_94116-94118.jpg",
    ["Linkable", "Plug & play", "Under-cabinet"]
  ),
  mkProduct(
    "55110",
    "LX Linear T8 22W 1500mm",
    "led-linear-lights",
    "22W",
    "2200 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/h3e6f3dl_51YDbHZ-PJL._AC_SL1100_.jpg",
    ["Retrofit tube", "Workshops"]
  ),
  mkProduct(
    "55120",
    "LX Linear Pro 36W 1500mm",
    "led-linear-lights",
    "36W",
    "3600 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/h3e6f3dl_51YDbHZ-PJL._AC_SL1100_.jpg",
    ["High-output", "Retail shelving"]
  ),

  // TRI-PROOF
  mkProduct(
    "70210",
    "LX TriProof 24W 1200mm",
    "led-tri-proof-light",
    "24W",
    "2400 lm",
    "4000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/fvrza80v_9290713.jpg",
    ["IK08", "Dust/water sealed", "Warehouse grade"]
  ),
  mkProduct(
    "70220",
    "LX TriProof 36W 1500mm",
    "led-tri-proof-light",
    "36W",
    "3600 lm",
    "4000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/fvrza80v_9290713.jpg",
    ["Linkable", "Cold storage compatible"]
  ),
  mkProduct(
    "70230",
    "LX TriProof 50W 1500mm",
    "led-tri-proof-light",
    "50W",
    "5000 lm",
    "5000K",
    "IP65",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/fvrza80v_9290713.jpg",
    ["High lumen", "Parking decks"]
  ),

  // DOWNLIGHTS
  mkProduct(
    "60110",
    "LX Downlight Round 12W",
    "recessed-downlight",
    "12W",
    "1100 lm",
    "3000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/10waaupc_47201-2-1600x_orig.jpg",
    ["Ø170 mm cutout", "Trim-less", "Retail/hospitality"]
  ),
  mkProduct(
    "60120",
    "LX Downlight Square 18W",
    "recessed-downlight",
    "18W",
    "1700 lm",
    "4000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/10waaupc_47201-2-1600x_orig.jpg",
    ["Square trim", "Office grade"]
  ),
  mkProduct(
    "60130",
    "LX Downlight Tilt 9W",
    "recessed-downlight",
    "9W",
    "850 lm",
    "3000K",
    "IP20",
    "3 years",
    "https://customer-assets.emergentagent.com/job_electrical-supplies-3/artifacts/10waaupc_47201-2-1600x_orig.jpg",
    ["±30° tilt", "Accent lighting"]
  ),
];

export const getCategory = (slug) =>
  CATEGORIES.find((c) => c.slug === slug);

// ---------- Derived/enriched product data for filters ----------
const SOCKET_BY_CATEGORY = {
  "led-bulbs": null, // detected from name
  "led-panels": "DALI",
  "led-floodlights": "—",
  "led-tri-proof-light": "—",
  "led-ceiling-lights": "—",
  "led-linear-lights": "G13",
  "recessed-downlight": "GU10",
};

const TAG_BY_INDEX = ["BESTSELLER", null, "NEW", null, null];

function parseNum(s) {
  const m = String(s).match(/[\d.]+/);
  return m ? parseFloat(m[0]) : 0;
}

function detectSocket(p) {
  const fromMap = SOCKET_BY_CATEGORY[p.category];
  if (fromMap && fromMap !== null && fromMap !== "—") return fromMap;
  const n = p.name.toUpperCase();
  if (n.includes("E27")) return "E27";
  if (n.includes("E14")) return "E14";
  if (n.includes("GU10")) return "GU10";
  if (n.includes("G9")) return "G9";
  if (n.includes("G13") || n.includes("T8") || n.includes("T5")) return "G13";
  return fromMap || "—";
}

function deriveFeatures(p) {
  const f = new Set();
  const txt = (p.highlights.join(" ") + " " + p.name).toLowerCase();
  if (txt.includes("dim")) f.add("dimmable");
  if (p.category === "led-panels" || p.category === "led-linear-lights") f.add("flicker-free");
  if (p.highlights.some((h) => /sensor/i.test(h))) f.add("motion-sensor");
  if (parseNum(p.watt) >= 36 && (p.ip === "IP65" || p.ip === "IP66")) f.add("emergency-battery");
  return [...f];
}

// Mutate each product to add derived fields used by filters/UI
PRODUCTS.forEach((p, i) => {
  p.lumenValue = parseNum(p.lumen);
  p.wattValue = parseNum(p.watt);
  p.cctValue = parseNum(p.cct);
  p.ipValue = parseNum(p.ip);
  p.warrantyYears = parseNum(p.warranty);
  p.socket = detectSocket(p);
  p.cri = p.category === "led-panels" ? 90 : 80;
  p.tag = TAG_BY_INDEX[i % TAG_BY_INDEX.length];
  p.features = deriveFeatures(p);
  p.minQty = 6;
  p.sku = `LD-${p.code}`;

  // Extended specs used on the product detail page
  p.stockQty = 60 + ((parseInt(p.code, 10) || 0) % 7) * 30;
  p.lifetimeHours = 50000;
  p.efficacy = Math.round((p.lumenValue / p.wattValue) || 100);
  p.beamAngle =
    p.category === "led-floodlights" ? "120°" :
    p.category === "led-tri-proof-light" ? "110°" :
    p.category === "led-linear-lights" ? "180°" :
    p.category === "recessed-downlight" ? "38°" :
    p.category === "led-bulbs" ? (p.name.includes("GU10") ? "38°" : "220°") :
    "120°";
  p.voltage = "AC 220–240V, 50/60Hz";
  p.powerFactor = "≥ 0.9";
  p.dimensions =
    p.category === "led-floodlights" ? "260 × 200 × 30 mm" :
    p.category === "led-panels" ? (p.name.includes("60x60") ? "595 × 595 × 9 mm" : p.name.includes("30x30") ? "295 × 295 × 9 mm" : p.name.includes("120x30") ? "1195 × 295 × 9 mm" : "Ø225 × 25 mm") :
    p.category === "led-linear-lights" ? "1200 × 25 × 30 mm" :
    p.category === "led-tri-proof-light" ? "1200 × 80 × 60 mm" :
    p.category === "led-ceiling-lights" ? "Ø300 × 50 mm" :
    p.category === "recessed-downlight" ? "Ø95 × 50 mm" :
    "60 × 110 mm";
  p.weight = p.wattValue > 80 ? "1.4 kg" : p.wattValue > 30 ? "0.8 kg" : p.wattValue > 10 ? "0.3 kg" : "0.05 kg";
  p.material =
    p.category === "led-floodlights" ? "Die-cast aluminium + tempered glass" :
    p.category === "led-tri-proof-light" ? "Polycarbonate + aluminium endcaps" :
    p.category === "led-panels" ? "Aluminium frame + PMMA diffuser" :
    p.category === "led-bulbs" ? "Aluminium + PC diffuser" :
    "Aluminium + polycarbonate";
  p.operatingTemp = "−25 °C to +45 °C";
  p.driver = "Built-in constant current, flicker-free";
  p.certifications = ["CE", "RoHS", "EAC"];
  p.description =
    `Professional-grade ${getCategory(p.category)?.name.toLowerCase() || "luminaire"} with constant-current driver, ` +
    `high luminous efficacy and full datasheet documentation. Suitable for commercial and industrial installations.`;
  p.applications =
    p.category === "led-floodlights" ? ["Façade lighting", "Parking lots", "Stadiums", "Logistics yards"] :
    p.category === "led-panels" ? ["Offices", "Schools & education", "Clinics", "Retail spaces"] :
    p.category === "led-tri-proof-light" ? ["Warehouses", "Cold storage", "Parking decks", "Food processing"] :
    p.category === "led-linear-lights" ? ["Workshops", "Retail shelving", "Under-cabinet", "Industrial"] :
    p.category === "led-ceiling-lights" ? ["Hallways", "Bathrooms", "Utility rooms", "Garages"] :
    p.category === "recessed-downlight" ? ["Hospitality", "Retail", "Residential", "Reception areas"] :
    ["Residential", "Decorative", "Hospitality", "Retail"];
});

export const FILTER_OPTIONS = {
  lumenMin: 200,
  lumenMax: Math.ceil(Math.max(...PRODUCTS.map((p) => p.lumenValue)) / 1000) * 1000,
  wattMin: 5,
  wattMax: Math.ceil(Math.max(...PRODUCTS.map((p) => p.wattValue)) / 10) * 10,
  cct: [2700, 3000, 4000, 5000, 6500],
  sockets: ["E27", "E14", "GU10", "G9", "G13", "DALI"],
  ips: [
    { code: 20, label: "IP20 (Indoor)" },
    { code: 44, label: "IP44 (Damp)" },
    { code: 54, label: "IP54 (Splash)" },
    { code: 65, label: "IP65 (Wet)" },
    { code: 66, label: "IP66 (Outdoor)" },
  ],
  warranties: [3, 5],
  cri: [80, 90, 95],
  features: [
    { key: "dimmable", label: "Dimmable" },
    { key: "flicker-free", label: "Flicker-Free" },
    { key: "emergency-battery", label: "Emergency Battery" },
    { key: "motion-sensor", label: "Motion Sensor" },
  ],
};

export const getProductsByCategory = (slug) =>
  PRODUCTS.filter((p) => p.category === slug);

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);

export const HERO_SLIDES = [
  {
    eyebrow: "B2B LED Lighting · Since 2008",
    title: "Industrial-grade LED light, delivered at trade scale.",
    subtitle:
      "From PAR16 retrofits to 150W floodlights — Leduro supplies installers, wholesalers and facility managers across the Baltics.",
    cta: { label: "Browse Catalogue", to: "/catalogue" },
    cta2: { label: "Request a Quote", to: "/where-to-find" },
    image:
      "https://images.unsplash.com/photo-1685459143178-2c24b66d44df?crop=entropy&cs=srgb&fm=jpg&w=1800&q=85",
    badge: "5-YEAR WARRANTY",
  },
  {
    eyebrow: "New Range · Q2 2026",
    title: "PROFlood series. Now up to 200W.",
    subtitle:
      "Cast aluminium housing, IP65 / IK08, asymmetric reflector options. Built for façades, sports fields and logistics yards.",
    cta: { label: "See Floodlights", to: "/catalogue/led-floodlights" },
    cta2: { label: "Download Datasheets", to: "/useful-information" },
    image:
      "https://images.unsplash.com/photo-1626776876729-bab4369a5a5a?auto=format&fit=crop&w=1800&q=85",
    badge: "IP65 · IK08",
  },
  {
    eyebrow: "Office & Education",
    title: "UGR<19 panels in stock, ready to ship.",
    subtitle:
      "595×595, 1200×300 and round formats. Flicker-free drivers, 5-year warranty, large project pricing on request.",
    cta: { label: "Explore Panels", to: "/catalogue/led-panels" },
    cta2: { label: "Where to Buy", to: "/where-to-find" },
    image:
      "https://images.unsplash.com/photo-1685459143178-2c24b66d44df?crop=entropy&cs=srgb&fm=jpg&w=1800&q=85",
    badge: "UGR < 19",
  },
];

export const ADVANTAGES = [
  {
    headline: "3",
    suffix: "YEAR",
    label: "WARRANTY",
    desc: "3 year warranty for LED bulbs",
  },
  {
    headline: "3",
    suffix: "YEAR",
    label: "WARRANTY",
    desc: "3 year warranty for LED luminaires",
  },
  {
    headline: "5",
    suffix: "YEAR",
    label: "WARRANTY",
    desc: "5 year warranty on LED panels",
  },
  {
    headline: "0s",
    suffix: "",
    label: "SPEED",
    desc: "Instant brightness — no warm-up time",
  },
  {
    headline: "100",
    suffix: "lm/W",
    label: "MORE LIGHT",
    desc: "Excellent light output, up to 100 lm/W",
  },
  {
    headline: "85",
    suffix: "%",
    label: "SAVINGS",
    desc: "Energy savings vs. incandescent bulbs",
  },
];

export const TESTIMONIALS = [
  {
    name: "Mārtiņš Bērziņš",
    role: "Procurement Manager",
    company: "Baltic Electric Wholesale, Rīga",
    quote:
      "We have been sourcing PAR16 and A60 retrofits from Leduro for three years. Failure rate is well below 0.5% and lead times have stayed predictable even through 2024 shortages.",
    image:
      "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?crop=entropy&cs=srgb&fm=jpg&w=400&q=85",
  },
  {
    name: "Kaspars Ozols",
    role: "Senior Electrical Contractor",
    company: "OZ Installations OÜ, Tallinn",
    quote:
      "Their tri-proof line replaced our entire warehouse lighting on a 40,000 m² site. Wired in two weeks, zero callbacks. The 5-year warranty made the spec sheet easy to sign off.",
    image:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Liene Krūmiņa",
    role: "Facility Director",
    company: "NorthLogix Distribution Center",
    quote:
      "We compared four suppliers across Europe. Leduro's photometric data was the most accurate, and the project pricing on 50W floodlights was unbeatable for 600 units.",
    image:
      "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Andris Kalniņš",
    role: "Technical Sales Lead",
    company: "VoltPro Vilnius, UAB",
    quote:
      "What I value most: technical answers within the same business day, and a real datasheet for every SKU. That's rare in this market and it's why we re-stock monthly.",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=80",
  },
];

export const PARTNERS = [
  "BALTIC ELECTRIC",
  "OZ INSTALLATIONS",
  "NORTHLOGIX",
  "VOLTPRO",
  "ELKO GROUP",
  "RIMI BALTIC",
  "MAXIMA",
  "TARTU TECH",
];
